import { BreadcrumbContainer } from './BreadcrumbContainer.styled';

import type { BlogCategory } from 'types/blog/category';
import type { ReactNode, FC } from 'react';
import type { PartnersCategory } from 'types/partners/category';

interface BreadcrumbsProps {
  /** An entry to build categories for. */
  crumbs: BlogCategory[] | PartnersCategory[];
  /** A breadcrumb to display in-front of the category, eg. `Blog > Category` or `Partners > Category` */
  crumb?: string;
}

export const Breadcrumbs: FC<BreadcrumbsProps> = ({ crumbs, crumb }) => (
  <BreadcrumbContainer>
    {crumbs
      ?.map(category => <span key={category.urlSlug}>{category?.shortName || category.name}</span>)
      .reduce<
        ReactNode[]
      >((prev: ReactNode[], curr) => (prev.length === 0 ? [curr] : [prev, ' | ', curr]), crumb ? [crumb] : [])}
  </BreadcrumbContainer>
);
